/**
 * Tags component.
 * @module components/theme/Tags/Tags
 */

import { Tags } from '@arpav/components/ArpavTheme';

export default Tags;
